var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "weituo" }, [
        _c("i", {
          staticClass: "el-icon-location-information",
          staticStyle: { color: "#63b947", "font-size": "25px" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "tittype" }, [
          _vm._v(_vm._s(_vm.$t("i18n_location_information")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "getGoodsInfo",
          attrs: {
            "label-position": "right",
            "label-width": "95px",
            size: "small",
            model: _vm.getGoodsDTO,
            rules: _vm.getGoodsDTORules
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("i18n_consignee_information") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            "box-sizing": "border-box"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.sendFeeForAir.name,
                                  expression: "!sendFeeForAir.name"
                                }
                              ],
                              staticClass: "poperWrap"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("i18n_No_default_contact")) +
                                  "\n              "
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addNewpop(3)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("i18n_add")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sendFeeForAir.name,
                                  expression: "sendFeeForAir.name"
                                }
                              ],
                              staticClass: "thatpoperWrap"
                            },
                            [
                              _c("div", { staticClass: "popWrap_l" }, [
                                _c("p", { staticClass: "lianxiren" }, [
                                  _vm._v(_vm._s(_vm.sendFeeForAir.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-left": "12px" } },
                                  [_vm._v(_vm._s(_vm.sendFeeForAir.tel))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "overText",
                                    staticStyle: { "margin-left": "20px" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.sendFeeForAir.country) +
                                        _vm._s(_vm.sendFeeForAir.city) +
                                        _vm._s(_vm.sendFeeForAir.area) +
                                        _vm._s(_vm.sendFeeForAir.address) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "popWrap_R" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.sendFeeForAir.isdefault,
                                          expression: "sendFeeForAir.isdefault"
                                        }
                                      ],
                                      staticClass: "morentype"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_default_address"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.sendFeeForAir.isdefault,
                                          expression: "!sendFeeForAir.isdefault"
                                        }
                                      ],
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.changeshowType(
                                            3,
                                            _vm.sendFeeForAir,
                                            "loca"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("i18n_set_to_default_address")
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.UpItem(
                                            3,
                                            _vm.sendFeeForAir
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addNewpop(3)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_add")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showReceive,
                                    expression: "showReceive"
                                  }
                                ]
                              },
                              _vm._l(_vm.SHpopList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "poperWrap",
                                    on: {
                                      click: function($event) {
                                        return _vm.changeShitem(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "popWrap_l" }, [
                                      _c("p", { staticClass: "lianxiren" }, [
                                        _vm._v(_vm._s(item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "margin-left": "12px" }
                                        },
                                        [_vm._v(_vm._s(item.tel))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "overText",
                                          staticStyle: { "margin-left": "20px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.country) +
                                              _vm._s(item.city) +
                                              _vm._s(item.area) +
                                              _vm._s(item.address) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "popWrap_R" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item.isdefault,
                                                expression: "item.isdefault"
                                              }
                                            ],
                                            staticClass: "morentype"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("i18n_default_address")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !item.isdefault,
                                                expression: "!item.isdefault"
                                              }
                                            ],
                                            staticStyle: { color: "#604aff" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.changeshowType(
                                                  3,
                                                  item,
                                                  "ajax"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "i18n_set_to_default_address"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#604aff" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.UpItem(3, item)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.SHpopList.length > 1,
                              expression: "SHpopList.length > 1"
                            }
                          ],
                          staticStyle: { margin: "10px 0 0 10px" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#696969" },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  _vm.showReceive = !_vm.showReceive
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.showReceive
                                      ? "i18n_Collapse"
                                      : "i18n_more_consignee_information"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("span", {
                            class: _vm.showReceive
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down"
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("i18n_shipper_information") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            "box-sizing": "border-box"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.countLIst_S.name == "",
                                  expression: "countLIst_S.name == ''"
                                }
                              ],
                              staticClass: "poperWrap"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("i18n_No_default_contact")) +
                                  "\n              "
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addNewpop(1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("i18n_add")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.countLIst_S.name,
                                  expression: "countLIst_S.name"
                                }
                              ],
                              staticClass: "thatpoperWrap"
                            },
                            [
                              _c("div", { staticClass: "popWrap_l" }, [
                                _c("p", { staticClass: "lianxiren" }, [
                                  _vm._v(_vm._s(_vm.countLIst_S.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-left": "12px" } },
                                  [_vm._v(_vm._s(_vm.countLIst_S.tel))]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "popWrap_R" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.countLIst_S.isdefault,
                                          expression: "countLIst_S.isdefault"
                                        }
                                      ],
                                      staticClass: "morentype"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_default_address"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.countLIst_S.isdefault,
                                          expression: "!countLIst_S.isdefault"
                                        }
                                      ],
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.changeshowType(
                                            1,
                                            _vm.countLIst_S,
                                            "loca"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("i18n_set_to_default_address")
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.UpItem(1, _vm.countLIst_S)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addNewpop(1)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_add")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFa,
                                    expression: "showFa"
                                  }
                                ]
                              },
                              _vm._l(_vm.FapopList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "poperWrap",
                                    on: {
                                      click: function($event) {
                                        return _vm.changeFAitem(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "popWrap_l" }, [
                                      _c("p", { staticClass: "lianxiren" }, [
                                        _vm._v(_vm._s(item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "margin-left": "12px" }
                                        },
                                        [_vm._v(_vm._s(item.tel))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "popWrap_R" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item.isdefault,
                                                expression: "item.isdefault"
                                              }
                                            ],
                                            staticClass: "morentype"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("i18n_default_address")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !item.isdefault,
                                                expression: "!item.isdefault"
                                              }
                                            ],
                                            staticStyle: { color: "#604aff" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.changeshowType(
                                                  1,
                                                  item,
                                                  "ajax"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "i18n_set_to_default_address"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#604aff" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.UpItem(1, item)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.FapopList.length > 1,
                              expression: "FapopList.length > 1"
                            }
                          ],
                          staticStyle: { margin: "10px 0 0 10px" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#696969" },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  _vm.showFa = !_vm.showFa
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.showFa
                                      ? "i18n_Collapse"
                                      : "i18n_More_consignor_information"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("span", {
                            class: _vm.showFa
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down"
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("i18n_door_to_door_pickup_service"),
                        "label-width": "125px"
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.changeTi },
                          model: {
                            value: _vm.toDoorForm.isGetGoodsToDoor,
                            callback: function($$v) {
                              _vm.$set(_vm.toDoorForm, "isGetGoodsToDoor", $$v)
                            },
                            expression: "toDoorForm.isGetGoodsToDoor"
                          }
                        },
                        [
                          _c("el-radio-button", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("i18n_no")))
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("i18n_yes")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.toDoorForm.isGetGoodsToDoor === true
                ? _c(
                    "div",
                    { staticStyle: { float: "left", width: "100%" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("i18n_pickup_location"),
                                    prop: "getGoodsAddress"
                                  }
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value: _vm.getGoodsDTO.getGoodsAddress,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.getGoodsDTO,
                                            "getGoodsAddress",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "getGoodsDTO.getGoodsAddress"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "background-color": "#5ab53c",
                                            color: "#fff"
                                          },
                                          attrs: { slot: "append" },
                                          on: { click: _vm.ShowTHList },
                                          slot: "append"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("i18n_address_book"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("i18n_pickup_time"),
                                    prop: "toDoorDate"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: _vm.addPls(
                                        "i18n_pickup_time",
                                        "select"
                                      ),
                                      "picker-options": _vm.pickerSetTime
                                    },
                                    on: { change: _vm.toDoorDateChange },
                                    model: {
                                      value: _vm.toDoorForm.toDoorDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.toDoorForm,
                                          "toDoorDate",
                                          $$v
                                        )
                                      },
                                      expression: "toDoorForm.toDoorDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("i18n_pickup_person"),
                                    prop: "getGoodsName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.getGoodsDTO.getGoodsName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.getGoodsDTO,
                                          "getGoodsName",
                                          $$v
                                        )
                                      },
                                      expression: "getGoodsDTO.getGoodsName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("i18n_contact_number"),
                                    prop: "getGoodsTel"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.getGoodsDTO.getGoodsTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.getGoodsDTO,
                                          "getGoodsTel",
                                          $$v
                                        )
                                      },
                                      expression: "getGoodsDTO.getGoodsTel"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _vm.cangkuitem.namec
                          ? _c("div", { staticClass: "SHInfo" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "i18n_send_goods_to_following_address"
                                    )
                                  ) + ":"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("i18n_Warehouse_Address")) +
                                    "：" +
                                    _vm._s(_vm.cangkuitem.addressc) +
                                    ", " +
                                    _vm._s(_vm.$t("i18n_contact_number")) +
                                    "：" +
                                    _vm._s(_vm.cangkuitem.tel)
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "myDialog",
          attrs: {
            visible: _vm.showMydialog,
            title: _vm.$t("i18n_pickup_address")
          },
          on: {
            "update:visible": function($event) {
              _vm.showMydialog = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    margin: "0 0 20px 0"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "390px" },
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t("i18n_name_or_phone_number"),
                            size: "medium"
                          },
                          on: {
                            clear: function($event) {
                              return _vm.getPeopletable()
                            }
                          },
                          nativeOn: {
                            keyup: function($event) {
                              return _vm.searchNameOrPhone($event)
                            }
                          },
                          model: {
                            value: _vm.nameOrPhone,
                            callback: function($$v) {
                              _vm.nameOrPhone = $$v
                            },
                            expression: "nameOrPhone"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-input__icon el-icon-search",
                            attrs: { slot: "prefix" },
                            slot: "prefix"
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "append", type: "primary" },
                              slot: "append"
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_Search")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", plain: "", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.showAdd(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_Create_new_address")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.edit
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "background-color": "#fff",
                        "border-radius": "20px",
                        padding: "20px",
                        "box-shadow":
                          "0px 0px 20px 0px rgba(193, 193, 193, 0.31)"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "85%",
                            margin: "0 auto",
                            "max-width": "600px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "8px",
                                "margin-left": "1px",
                                display: "flex"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "grid-content",
                                    staticStyle: {
                                      "margin-right": "5px",
                                      "min-width": "100px"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "line-height": "40px" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("i18n_contact_person"))
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "grid-content" },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "230px" },
                                      attrs: {
                                        placeholder: _vm.addPls(
                                          "i18n_contact_person",
                                          "input"
                                        )
                                      },
                                      model: {
                                        value: _vm.submitForm.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.submitForm, "name", $$v)
                                        },
                                        expression: "submitForm.name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "grid-content",
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "margin-right": "10px",
                                      "min-width": "75px"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "line-height": "40px" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("i18n_contact_info"))
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "grid-content" },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "220px" },
                                      attrs: {
                                        placeholder: _vm.addPls(
                                          "i18n_contact_info",
                                          "input"
                                        )
                                      },
                                      model: {
                                        value: _vm.submitForm.tel,
                                        callback: function($$v) {
                                          _vm.$set(_vm.submitForm, "tel", $$v)
                                        },
                                        expression: "submitForm.tel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              staticStyle: { "margin-bottom": "8px" },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "grid-content" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "line-height": "1",
                                        "word-break": "break-word"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_contact_address"))
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 18 } }, [
                                _c(
                                  "div",
                                  { staticClass: "grid-content" },
                                  [
                                    _c("el-cascader", {
                                      staticStyle: { width: "260px" },
                                      attrs: {
                                        options: _vm.jackCitylist,
                                        placeholder: _vm.addPls(
                                          "i18n_pickup_address",
                                          "select"
                                        ),
                                        clearable: "",
                                        props: _vm.defaultParams2
                                      },
                                      on: { change: _vm.handleChange },
                                      model: {
                                        value: _vm.value,
                                        callback: function($$v) {
                                          _vm.value = $$v
                                        },
                                        expression: "value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              staticStyle: { "margin-bottom": "8px" },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "grid-content" }, [
                                  _c("div", {
                                    staticStyle: {
                                      "line-height": "40px",
                                      width: "10px",
                                      height: "10px"
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 18 } }, [
                                _c(
                                  "div",
                                  { staticClass: "grid-content" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "2",
                                        placeholder: _vm.addPls(
                                          "i18n_Detailed_address",
                                          "input"
                                        )
                                      },
                                      model: {
                                        value: _vm.submitForm.address,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.submitForm,
                                            "address",
                                            $$v
                                          )
                                        },
                                        expression: "submitForm.address"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              staticStyle: { "margin-bottom": "8px" },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "grid-content" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { "line-height": "40px" } },
                                    [_vm._v(_vm._s(_vm.$t("i18n_label")))]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 18 } }, [
                                _c(
                                  "div",
                                  { staticClass: "grid-content" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.addPls(
                                          "i18n_label",
                                          "input"
                                        )
                                      },
                                      model: {
                                        value: _vm.submitForm.tag,
                                        callback: function($$v) {
                                          _vm.$set(_vm.submitForm, "tag", $$v)
                                        },
                                        expression: "submitForm.tag"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "330px",
                                margin: "0 auto",
                                "text-align": "center"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-checkbox", {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: { "text-color": "#5AB53C" },
                                    model: {
                                      value: _vm.submitForm.isdefault,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.submitForm,
                                          "isdefault",
                                          $$v
                                        )
                                      },
                                      expression: "submitForm.isdefault"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "margin-bottom": "8px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "i18n_set_to_default_address"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    background: "#5AB53C",
                                    border: "1px solid #5AB53C",
                                    "border-radius": "5px",
                                    color: "#fff"
                                  },
                                  on: { click: _vm.addAddr }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.submitForm.id
                                          ? "i18n_edit"
                                          : "i18n_add"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "info" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showAdd(false)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("i18n_Close")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.edit
                ? _c(
                    "el-table",
                    {
                      ref: "Table",
                      staticStyle: { width: "100%", overflow: "hidden" },
                      attrs: {
                        size: "mini",
                        height: "300",
                        "tooltip-effect": "dark",
                        data: _vm.tableData,
                        "max-height": "200",
                        "highlight-current-row": "",
                        border: ""
                      },
                      on: { "row-click": _vm.rowClick }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Name"),
                          width: "100",
                          align: "center",
                          prop: "name"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Phone"),
                          width: "120",
                          align: "center",
                          prop: "tel"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_contact_address"),
                          "show-overflow-tooltip": "",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.parvince) +
                                      "\n            " +
                                      _vm._s(scope.row.country) +
                                      "\n            " +
                                      _vm._s(scope.row.city) +
                                      "\n            " +
                                      _vm._s(scope.row.area) +
                                      "\n            " +
                                      _vm._s(scope.row.address) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          795524647
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Operation"),
                          align: "center",
                          width: "200"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.setDefault(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style: scope.row.isdefault
                                            ? "color:#604AFF"
                                            : "color:#9A9A9A"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                scope.row.isdefault
                                                  ? "i18n_Default"
                                                  : "i18n_set_to_default"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleEdit(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handleDeleteAddress(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_delete")))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3937690797
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.edit
                ? _c("el-alert", {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      title: _vm.$t("i18n_Click_line_select_address"),
                      type: "info",
                      center: "",
                      "show-icon": ""
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            width: "480px",
            visible: _vm.addressDialogVisible,
            closeOnClickModal: false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addressDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "wrap_count" }, [
            _c("div", { staticClass: "header_logo" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      !_vm.itemid
                        ? "i18n_Create_new_address"
                        : "i18n_Modify_Address"
                    )
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "count" },
              [
                _c(
                  "el-form",
                  {
                    ref: "editAddress",
                    attrs: {
                      "label-position": "right",
                      "label-width": "125px",
                      rules: _vm.fromPopRules,
                      model: _vm.fromPop
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("i18n_contact_person"),
                          prop: "name"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.addPls(
                              "i18n_contact_person",
                              "input"
                            )
                          },
                          model: {
                            value: _vm.fromPop.name,
                            callback: function($$v) {
                              _vm.$set(_vm.fromPop, "name", $$v)
                            },
                            expression: "fromPop.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("i18n_contact_info"),
                          prop: "tel"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.addPls(
                              "i18n_contact_info",
                              "input"
                            )
                          },
                          model: {
                            value: _vm.fromPop.tel,
                            callback: function($$v) {
                              _vm.$set(_vm.fromPop, "tel", $$v)
                            },
                            expression: "fromPop.tel"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.changeNum == 2
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("i18n_contact_address"),
                              prop: "ssqnames"
                            }
                          },
                          [
                            _c("el-cascader", {
                              ref: "refSsqname",
                              staticStyle: { width: "100%" },
                              attrs: {
                                options: _vm.Guojialist,
                                props: _vm.defaultParams
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.namec))
                                        ]),
                                        _vm._v(" "),
                                        !node.isLeaf ? _c("span") : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3298384561
                              ),
                              model: {
                                value: _vm.fromPop.ssqnames,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "ssqnames", $$v)
                                },
                                expression: "fromPop.ssqnames"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.changeNum == 3
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("i18n_contact_address"),
                              prop: "ssqnames"
                            }
                          },
                          [
                            _c("el-cascader", {
                              ref: "refSsqname",
                              staticStyle: { width: "100%" },
                              attrs: {
                                options: _vm.citylist,
                                props: _vm.defaultParams
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.namec))
                                        ]),
                                        _vm._v(" "),
                                        !node.isLeaf ? _c("span") : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3298384561
                              ),
                              model: {
                                value: _vm.fromPop.ssqnames,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "ssqnames", $$v)
                                },
                                expression: "fromPop.ssqnames"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.changeNum != 1
                      ? _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.addPls(
                                  "i18n_Detailed_address",
                                  "input"
                                ),
                                type: "textarea"
                              },
                              model: {
                                value: _vm.fromPop.address,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "address", $$v)
                                },
                                expression: "fromPop.address"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "type" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.fromPop.isdefault,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "isdefault", $$v)
                              },
                              expression: "fromPop.isdefault"
                            }
                          },
                          [
                            _c("el-checkbox", { attrs: { name: "type" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("i18n_set_to_default_address"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.itemid ? "i18n_edit" : "i18n_add")
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.addressDialogVisible = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_cancel")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00204495", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00204495","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/component/addressInfo.vue
// module id = null
// module chunks = 